import React from 'react'
import './ContactForm.css'

const ContactForm = () => {
  return (
    <React.Fragment>
      <section id="contact">
        <form className="form-container">
          <h1 style={{ color: '#7c00d5', stroke: '1px solid white' }}>
            Shoot us a message <i className="fa-solid fa-paper-plane"></i>
          </h1>
          <input id="name" type="text" placeholder="*Name " required />
          <input id="email" type="text" placeholder="*Your email " required />
          <input id="topic" type="text" placeholder="Topic " />
          <textarea
            id="message"
            placeholder="*What can we do for you? "
            required
          ></textarea>
          <input id="button" type="submit" value="Send" />
          <p
            style={{
              color: 'white',
              fontSize: 'smaller',
              textAlign: 'start',
              marginBottom: '20px',
              fontWeight: '100',
            }}
          >
            * required
          </p>
        </form>
      </section>
    </React.Fragment>
  )
}

export default ContactForm
